<div class="property-status">
  <span class="property-status-point" [ngClass]="getStatusLabel(status)"></span>
  <span [ngClass]="getStatusLabel(status)">{{getStatusLabel(status) | titlecase}}</span>
</div>